import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const FILES = {
  zbornik: "/Prilozi/ZBORNIK DOKUMENTOVANIH INFORMACIJA.pdf",
  politika: "/Prilozi/Odluka o usvajanju politike kvaliteta.pdf",
  sjednica:
    "/Prilozi/2. Sjednica Odbora za kvalitet i samovrednovanje 2025.pdf",
  stimulisanjeStudenata:
    "/Prilozi/Odluka o stimulisanju i vrednovanju ucesca studenata.pdf",
};

const QUICK_NAV_IDS = [
  "principi",
  "odbor",
  "pracenje",
  "fokus",
  "dokumenta",
  "zbornik",
];

const STAT_ICONS = [
  "fas fa-shield-alt",
  "fas fa-chart-line",
  "fas fa-sync-alt",
];

const OVERVIEW_ICONS = ["fas fa-bullseye", "fas fa-users", "fas fa-lightbulb"];

const MONITORING_ICONS = [
  "fas fa-comments",
  "fas fa-chalkboard-teacher",
  "fas fa-graduation-cap",
  "fas fa-clipboard-check",
];

const DOCUMENT_ICONS = [
  "fas fa-book-open",
  "fas fa-file-signature",
  "fas fa-clipboard-list",
  "fas fa-user-graduate",
];

const DOCUMENT_LINKS = [
  FILES.zbornik,
  FILES.politika,
  FILES.sjednica,
  FILES.stimulisanjeStudenata,
];

function SectionHeader({ eyebrow, title, lead }) {
  return (
    <div className="quality-section-header">
      <span className="quality-section-header__eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
      <p>{lead}</p>
    </div>
  );
}

function ObezbjedjivanjeKvaliteta() {
  const { t } = useTranslation();
  const copy = t("qualityPage", { returnObjects: true });

  return (
    <>
      <Navbar />
      <Bredcom title={copy.breadcrumbHome} subtitle={copy.pageTitle} />

      <main className="quality-page">
        <div className="container quality-page__container">
          <section className="quality-hero">
            <div className="quality-hero__content">
              <span className="quality-hero__eyebrow">{copy.heroEyebrow}</span>
              <h1>{copy.heroTitle}</h1>
              <p>{copy.heroText}</p>

              <div className="quality-hero__badges">
                {copy.heroBadges.map((badge) => (
                  <span key={badge} className="quality-badge">
                    {badge}
                  </span>
                ))}
              </div>

              <div className="quality-hero__actions">
                <a
                  href={FILES.zbornik}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="quality-btn quality-btn--primary"
                >
                  {copy.primaryAction}
                  <i className="fas fa-arrow-right" />
                </a>

                <a href="#dokumenta" className="quality-btn quality-btn--ghost">
                  {copy.secondaryAction}
                </a>
                <Link
                  to="/obezbjedjivanje-kvaliteta/ankete"
                  className="quality-btn quality-btn--ghost quality-btn--surveys"
                >
                  {copy.tertiaryAction}
                  <i className="fas fa-chart-pie" />
                </Link>
              </div>
            </div>

            <div className="quality-hero__stats">
              {copy.stats.map((item, index) => (
                <article key={item.title} className="quality-stat-card">
                  <div className="quality-stat-card__icon">
                    <i className={STAT_ICONS[index]} />
                  </div>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </section>

          <div className="row quality-layout">
            <div className="col-lg-8 col-md-12">
              <section
                id="principi"
                className="quality-section quality-surface"
              >
                <SectionHeader {...copy.sections.overview} />
                <div className="quality-card-grid quality-card-grid--three">
                  {copy.sections.overview.cards.map((card, index) => (
                    <article key={card.title} className="quality-info-card">
                      <div className="quality-info-card__icon">
                        <i className={OVERVIEW_ICONS[index]} />
                      </div>
                      <h3>{card.title}</h3>
                      <p>{card.text}</p>
                    </article>
                  ))}
                </div>
              </section>

              <section id="odbor" className="quality-section quality-surface">
                <SectionHeader {...copy.sections.committee} />
                <div className="quality-list-card">
                  {copy.sections.committee.items.map((item, index) => (
                    <div key={item} className="quality-list-card__item">
                      <span>{String(index + 1).padStart(2, "0")}</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </section>

              <section
                id="pracenje"
                className="quality-section quality-surface"
              >
                <SectionHeader {...copy.sections.monitoring} />
                <div className="quality-card-grid quality-card-grid--two">
                  {copy.sections.monitoring.blocks.map((block, index) => (
                    <article key={block.title} className="quality-process-card">
                      <div className="quality-process-card__top">
                        <i className={MONITORING_ICONS[index]} />
                        <h3>{block.title}</h3>
                      </div>
                      <p>{block.text}</p>
                    </article>
                  ))}
                </div>
              </section>

              <section className="quality-section quality-surface quality-surface--accent">
                <SectionHeader {...copy.sections.surveys} />
                <div className="quality-bullet-grid">
                  {copy.sections.surveys.bullets.map((bullet) => (
                    <div key={bullet} className="quality-bullet-item">
                      <i className="fas fa-check-circle" />
                      <span>{bullet}</span>
                    </div>
                  ))}
                </div>
              </section>

              <section id="fokus" className="quality-section quality-surface">
                <SectionHeader {...copy.sections.focus} />
                <div className="quality-timeline">
                  {copy.sections.focus.timeline.map((step, index) => (
                    <article
                      key={step.title}
                      className="quality-timeline__item"
                    >
                      <div className="quality-timeline__number">
                        {index + 1}
                      </div>
                      <div className="quality-timeline__content">
                        <h3>{step.title}</h3>
                        <p>{step.text}</p>
                      </div>
                    </article>
                  ))}
                </div>
              </section>

              <section
                id="dokumenta"
                className="quality-section quality-surface"
              >
                <SectionHeader {...copy.sections.docs} />
                <div className="quality-card-grid quality-card-grid--three">
                  {copy.documents.map((doc, index) => (
                    <article key={doc.title} className="quality-document-card">
                      <span className="quality-document-card__tag">
                        {doc.tag}
                      </span>
                      <div className="quality-document-card__icon">
                        <i className={DOCUMENT_ICONS[index]} />
                      </div>
                      <h3>{doc.title}</h3>
                      <p>{doc.text}</p>
                      <a
                        href={DOCUMENT_LINKS[index]}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="quality-document-card__link"
                      >
                        {doc.cta}
                        <i className="fas fa-external-link-alt" />
                      </a>
                    </article>
                  ))}
                </div>
              </section>

              <section id="zbornik" className="quality-section quality-surface">
                <SectionHeader {...copy.sections.reader} />
                <div className="quality-pdf-frame">
                  <div className="quality-pdf-frame__top">
                    <h3>{copy.previewTitle}</h3>
                    <a
                      href={FILES.zbornik}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fas fa-expand" />
                    </a>
                  </div>
                  <iframe
                    title={copy.previewTitle}
                    src={`${FILES.zbornik}#view=FitH`}
                    loading="lazy"
                  />
                  <p className="quality-pdf-frame__fallback">
                    {copy.previewFallback}
                  </p>
                </div>
              </section>
            </div>

            <div className="col-lg-4 col-md-12">
              <aside className="quality-aside quality-sticky-card">
                <div className="quality-surface">
                  <h3 className="quality-aside__title">{copy.quickNavTitle}</h3>
                  <nav
                    className="quality-anchor-nav"
                    aria-label={copy.quickNavTitle}
                  >
                    {copy.quickNav.map((label, index) => (
                      <a
                        key={QUICK_NAV_IDS[index]}
                        href={`#${QUICK_NAV_IDS[index]}`}
                      >
                        <span>{label}</span>
                        <i className="fas fa-angle-right" />
                      </a>
                    ))}
                  </nav>
                </div>

                <div className="quality-surface quality-surface--dark">
                  <h3 className="quality-aside__title">{copy.asideTitle}</h3>
                  <div className="quality-aside__items">
                    {copy.asideItems.map((item) => (
                      <div key={item} className="quality-aside__item">
                        <i className="fas fa-check" />
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="quality-surface quality-cta-card">
                  <h3>{copy.documents[2].title}</h3>
                  <p>{copy.documents[2].text}</p>
                  <a
                    href={FILES.sjednica}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="quality-btn quality-btn--primary quality-btn--full"
                  >
                    {copy.documents[2].cta}
                    <i className="fas fa-file-pdf" />
                  </a>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default ObezbjedjivanjeKvaliteta;
